





import { ResultSortScoreCriteria } from '@empathybroker/tsclient-search';

import { ScoreCriteriaDetailTypeEnum } from '../../enums';

import { ExplainScoreCriteriaMessages } from '../../models';

import { ArrayUtils, ExplainUtils } from '../../utils';

import RadarChart from '../analytics/radar-chart.component.vue';
import { Params } from '../insights/abstract.component';
import { Config as RadarChartConfig, Data as RadarChartData } from '../insights/radar-chart/radar-chart.component';

export default {
  name: 'explain-result-score-radar-chart',
  props: {
    result: {
      type: Object,
      required: true
    },
    defaultCriteriaDetailTypes: {
      type: Array,
      default: () => []
    },
    messages: {
      type: Object,
      required: true
    }
  },
  components: {
    RadarChart
  },
  computed: {
    scoreCriteria: function (): ResultSortScoreCriteria {
      return ExplainUtils.getResultScoreCriteria(this.result);
    },
    criteriaDetailTypes: function (): (ScoreCriteriaDetailTypeEnum | string)[] {
      return ArrayUtils.union(this.defaultCriteriaDetailTypes, Object.keys(this.scoreCriteria.details));
    },
    params: function (): Params<RadarChartConfig, RadarChartData> {
      return {
        config: {
          values: [this.result.id]
        },
        data: this.criteriaDetailTypes.map((criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)) => ({
          id: criteriaDetailType,
          label: this.getCriteriaDetailMessages(criteriaDetailType).label,
          values: {
            [this.result.id]: this.getCriteriaDetailValue(criteriaDetailType)
          }
        }))
      };
    }
  },
  methods: {
    getCriteriaDetailMessages: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): ExplainScoreCriteriaMessages {
      return ExplainUtils.getResultScoreCriteriaDetailMessages(criteriaDetailType, this.messages);
    },
    getCriteriaDetailValue: function (criteriaDetailType: (ScoreCriteriaDetailTypeEnum | string)): number {
      const criteriaDetail = this.scoreCriteria.details[criteriaDetailType];
      return (!!criteriaDetail ? criteriaDetail.value : 0);
    }
  }
};

